import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import { Icon } from '@kurtosys/ksys-app-components/dist/components/base/Icon/Icon';

export default InjectedStyledComponent(Icon, 'logoutButton', ['icon']);